var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollarSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77.75A.748.748 0 008.02 0a.748.748 0 00-.75.75v1.49c-.098.004-.194.01-.291.02-.725.059-1.475.23-2.1.628-.65.412-1.125 1.05-1.297 1.93-.122.635-.063 1.213.19 1.726.25.5.654.862 1.088 1.131.819.506 1.934.79 2.903 1.038l.072.018c1.06.269 1.956.503 2.553.875.281.175.447.35.534.528.085.166.132.4.063.766-.09.46-.419.84-1.078 1.09-.675.257-1.625.341-2.738.185-.706-.103-1.93-.397-2.593-.69a.751.751 0 00-.61 1.371c.835.369 2.213.688 2.99.8h.004c.103.016.206.028.31.038v1.556c0 .416.334.75.75.75.415 0 .75-.334.75-.75v-1.519a5.84 5.84 0 001.671-.344c.997-.378 1.803-1.1 2.016-2.206.122-.634.062-1.212-.19-1.725-.25-.5-.654-.862-1.088-1.131-.82-.506-1.935-.79-2.903-1.037l-.072-.02C7.144 7 6.247 6.767 5.65 6.395c-.282-.175-.447-.35-.535-.528-.084-.166-.131-.4-.062-.766.09-.462.315-.75.63-.95.342-.216.823-.35 1.417-.397 1.196-.097 2.596.166 3.559.39a.75.75 0 10.347-1.459 17.842 17.842 0 00-2.235-.39V.75H8.77z",
    fill: "#093F45"
  })));
}

export default SvgDollarSign;